import React, { Component } from 'react';

import Checkbox from 'material-ui/Checkbox';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { dataGridFiltersOperations } from '../../redux/dataGridFilters';

const styles = {
  wrapper: {
    padding: '5px'
  },
  icon: {
    marginRight: '4px'
  },
  label: {
    width: 'unset',
    marginRight: '3px'
  }
};

class AutomaticSpatialQueryToggle extends Component {
  state = {
    checked: false
  };

  onCheck = () => {
    const checked = !this.state.checked;
    this.setState({ checked }, () =>
      this.props.toggleAutomaticSpatialQuery(this.state.checked)
    );
  };

  render() {
    return (
      <div style={styles.wrapper} className="esri-widget">
        <Checkbox
          checked={this.state.checked}
          label="Filter by map extent"
          onCheck={this.onCheck}
          iconStyle={styles.icon}
          labelStyle={styles.label}
        />
      </div>
    );
  }
}

const mapStateToProps = null;

const mapDispatchToProps = function(dispatch) {
  return bindActionCreators(
    {
      ...dataGridFiltersOperations
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AutomaticSpatialQueryToggle);



// WEBPACK FOOTER //
// ./src/esri/widgets/AutomaticSpatialQueryToggle.js